import { Injectable } from '@angular/core';
import { SettingsService } from '../../settings/services/settings.service';
import { AuthService } from '../../auth/services/auth.service';
import { Observable } from 'rxjs/Observable';
import { HttpClientModule, HttpResponse, HttpHeaders, HttpClient, HttpParams  } from '@angular/common/http';

@Injectable()
export class PermissionService {
    appSettings = this.settingsService.Get();
    private accessEndpoint = 'hasaccess';
    private addonsEndpoint = 'addons';

    constructor(private httpService: HttpClient, private settingsService: SettingsService,
        private authService: AuthService) {
        this.authService.getUserLoginState();
    }


    verifyProductAccess() {
        if (this.authService.getAuthorisationHeader() == null) {
            return Observable.of(this.createFalseResponse());
        }
        return this.httpService.get(this.appSettings.apiUrl + '/' + this.accessEndpoint, { headers: this.authService.getAuthorisationHeader() });
    }

    getUserAddons() {
        if (this.authService.getAuthorisationHeader() == null) {
            return Observable.of(this.createFalseResponse());
        }
        return this.httpService.get(this.appSettings.apiUrl + '/' + this.addonsEndpoint, { headers: this.authService.getAuthorisationHeader() });
    }

    private createFalseResponse() {
        return new Response({ body: false});
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/permission.service.ts